import { TopbarComponent } from "./topbarComponent";

export const CaregiverTopbar = TopbarComponent;
